/**
 * Transform an object to a URL Encoded params String which
 * you can use in your HTTP requests
 *
 * @param object
 * @returns {*}
 */
export function toQueryParams(object) {
  const reducer = (obj, parentPrefix = null) => (prev, key) => {
    const val = obj[key];
    key = encodeURIComponent(key);
    const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key;

    if (val == null || typeof val === 'function') {
      prev.push(`${prefix}=`);
      return prev;
    }

    if (['number', 'boolean', 'string'].includes(typeof val)) {
      prev.push(`${prefix}=${encodeURIComponent(val)}`);
      return prev;
    }

    prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'));
    return prev;
  };

  return Object.keys(object).reduce(reducer(object), []).join('&');
}

export const Toast ={
  show({message, type}) {
    document.dispatchEvent(
      new CustomEvent('toast:show', {detail: {message, type}}));
  }
}


/**
 * It takes a function to execute, and optionally a delay
 */
export function debounce(func, delay = 0) {
  let timeoutId;

  return function() {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, arguments);
    }, delay);
  }
};
